import React from 'react';
import { Icon, TextLink } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { WarrantyContainer } from './styles/CarinfoWrapper.styles';
export const WarrantyInfoLink = ({ vehicle }) => {
    var _a, _b;
    const warranties = (_b = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.basic) === null || _a === void 0 ? void 0 : _a.warrantyInfo) === null || _b === void 0 ? void 0 : _b.warranties;
    const scrollToWarrantiesText = useI18n({
        id: 'nemo.ui.sc.pdp.scroll.to.warranty.text',
        defaultMessage: '',
    });
    if (!warranties || (warranties === null || warranties === void 0 ? void 0 : warranties.length) === 0) {
        return null;
    }
    const scrollToWarranties = () => {
        var _a;
        if (typeof document !== 'undefined') {
            (_a = document
                .querySelector('[data-testid="warranties"]')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    return (React.createElement(WarrantyContainer, null,
        React.createElement(Icon, { name: "warranty", size: "xs" }),
        React.createElement(TextLink, { "data-testid": "scroll-to-warranty", href: "#warranties", onClick: scrollToWarranties, iconPosition: "leading", margin: ['10px', '0px', '10px', '0px'], rel: "noopener", size: "sm", variant: "standalone" }, scrollToWarrantiesText),
        React.createElement(Icon, { name: "forward", size: "xs" })));
};
